// extracted by mini-css-extract-plugin
module.exports = {"inner":"EditorFooter_inner__3KiLh","errorLogs":"EditorFooter_errorLogs__3s8Pb"};